export default Object.freeze({
  PRIVATE: 'PRIVATE',
  PUBLIC: 'PUBLIC'
})
